export default __webpack_public_path__ + "static/media/21-1.18d65670.mp3";